import { useCallback } from "react"
import { validatePhoneNumber } from "ui/Input/PhoneInput"

export const useStaffFormActions = ({ setFormData, setTripAssignments, validationErrors, setValidationErrors, t }) => {
  const handleInputChange = useCallback(
    (field, value) => {
      if (field === "experiences") {
        setFormData((prev) => {
          const selectedTripIds = value || []
          const currentTripIds = prev.experiences || []

          const removedTripIds = currentTripIds.filter((id) => !selectedTripIds.includes(id))
          const addedTripIds = selectedTripIds.filter((id) => !currentTripIds.includes(id))
          setTripAssignments((prevAssignments) => {
            let updatedAssignments = [...prevAssignments]

            removedTripIds?.forEach((tripId) => {
              const assignmentIndex = updatedAssignments.findIndex((a) => a.trip_id === tripId)
              if (assignmentIndex !== -1) {
                const assignment = updatedAssignments[assignmentIndex]
                if (assignment.id) {
                  updatedAssignments[assignmentIndex] = { ...assignment, _destroy: true }
                } else {
                  updatedAssignments = updatedAssignments.filter((a) => a.trip_id !== tripId)
                }
              }
            })

            addedTripIds?.forEach((tripId) => {
              const existingIndex = updatedAssignments.findIndex((a) => a.trip_id === tripId)
              if (existingIndex !== -1) {
                if (updatedAssignments[existingIndex]._destroy) {
                  updatedAssignments[existingIndex] = { ...updatedAssignments[existingIndex], _destroy: false }
                }
              } else {
                updatedAssignments.push({
                  trip_id: tripId,
                  _destroy: false
                })
              }
            })

            return updatedAssignments
          })

          return { ...prev, [field]: value }
        })

        if (validationErrors[field]) {
          setValidationErrors((prev) => ({ ...prev, [field]: undefined }))
        }
      } else {
        setFormData((prev) => ({ ...prev, [field]: value }))

        if (validationErrors[field]) {
          setValidationErrors((prev) => ({ ...prev, [field]: undefined }))
        }
      }
    },
    [setFormData, setTripAssignments, setValidationErrors, validationErrors]
  )

  const handlePhoneChange = useCallback(
    async ({ countryCode, fullNumber }) => {
      setFormData((prev) => ({
        ...prev,
        phone: fullNumber,
        phoneCountryCode: countryCode
      }))

      if (fullNumber && fullNumber.trim()) {
        try {
          await validatePhoneNumber(fullNumber)
          if (validationErrors.phone) {
            setValidationErrors((prev) => ({ ...prev, phone: undefined }))
          }
        } catch (error) {
          setValidationErrors((prev) => ({
            ...prev,
            phone: t("staff.add_staff_modal.validation.phone_invalid") || "Please enter a valid phone number"
          }))
        }
      } else {
        if (validationErrors.phone) {
          setValidationErrors((prev) => ({ ...prev, phone: undefined }))
        }
      }
    },
    [setFormData, setValidationErrors, t, validationErrors.phone]
  )

  return {
    handleInputChange,
    handlePhoneChange
  }
}
